import { useSession } from '@/providers/session-provider';
import { isset } from '@/legacy/utils/utils';
import { useCallback, useEffect, useRef } from 'react';
import { CallCallbackParams } from '../tours/tour-controller';
import { PostHogActionProperties } from '../tours/posthog-action-properties';
import posthog, { Properties } from 'posthog-js';
import { useSwitchWorkspace } from '@/hooks/use-switch-workspace';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';
import { LegacyPath } from './LegacyIframes';
import { usersPathFilterAccess } from '@/utils/users-path-filter';
import NotFound from '@/pages/public/NotFound';
import { Alert, AlertTitle } from '@mui/material';
import CampaignRounded from '@mui/icons-material/CampaignRounded';
import { useTranslation } from 'react-i18next';

let iframe: Window | null = null;
const oldHost: string = import.meta.env.VITE_OLD_LEGACY_APP_ROOT as string;
const BETTER_AUTH_UI_ENABLED = ['1', 'true', 'yes', 'on'].includes(
    (import.meta.env.VITE_BETTER_AUTH_UI_ENABLED || '').toLowerCase(),
);

const pathMatch: LegacyPath[] = [
    {
        oldPath: 'new_dashboard',
        newPath: 'home',
        andieDescription: 'This is the legacy dashboard page. It shows a overview of your workspace.',
    },
    {
        oldPath: 'drafts',
        newPath: 'planning/drafts',
        andieDescription:
            'This is the legacy draft legacy post page. It shows automatic and manual post drafts. You can edit, preview and delete legacy post drafts here.',
    },
    {
        oldPath: 'queue',
        newPath: 'planning/queue',
        andieDescription:
            'This is the legacy queue page. This Queues mean are a group of times of weekdays that your posts can be allocated to.  It shows your queues. You can create, edit and delete queues here.',
    },
    {
        oldPath: 'produce_content',
        newPath: 'produce-content',
        andieDescription: 'Legacy post creation page. Here you can create your legacy posts.',
    },
    {
        oldPath: 'team_management/pool',
        newPath: 'planning/workflow-pool',
        andieDescription: 'See your team post aproval pool. Here you can approve or reject posts.',
    },
    {
        oldPath: 'team_management/posts',
        newPath: 'planning/posts-workflow',
        andieDescription:
            'See your team post by aproval state. Here you can manage your team posts, approve or reject posts.',
    },
    {
        oldPath: 'schedule',
        newPath: 'planning/calendar',
        andieDescription:
            'Calendar page that shows your scheduled legacy posts, legacy drafts. You can edit and delete posts here.',
    },

    {
        oldPath: 'new_analytics/overview',
        newPath: 'reports/basic',
        andieDescription:
            'This page is used to see your legacy social media analytics. It shows your social media analytics in a basic way.',
    },
    {
        oldPath: 'new_analytics/dashboards',
        newPath: 'reports/advanced',
        andieDescription: 'This page is used to see your legacy social media dashboards.',
    },
    {
        oldPath: 'new_analytics/ads_overview',
        newPath: 'reports/ads-overview',
        andieDescription:
            'This page is used to see your legacy social media ads analytics. It shows your social media ads analytics in a basic way.',
    },
    {
        oldPath: 'new_analytics/ads_dashboards',
        newPath: 'reports/ads-campaigns',
        andieDescription: 'This page is used to see your legacy social media ads dashboards.',
    },
    {
        oldPath: 'competitors/analytics',
        newPath: 'reports/competitors',
        andieDescription: 'This page is used to see your legacy competitors dashboards.',
    },
    {
        oldPath: 'new_analytics',
        newPath: 'reports',
        andieDescription: 'This page is used to see your legacy social media analytics.',
    },

    {
        oldPath: 'dashboard/inbox',
        newPath: 'inbox',
        andieDescription:
            'Shows the inboxes of your social media profiles. You can manage your inboxes here.',
    },
    {
        oldPath: 'dashboard/feed',
        newPath: 'feeds/posts',
        andieDescription: 'Shows the feed of your social media profiles. You can manage your feed here.',
    },
    {
        oldPath: 'dashboard/posts',
        newPath: 'feeds/my-posts',
        andieDescription: 'Shows the legacy posts that were published by swonkie on your behalf. ',
    },
    {
        oldPath: 'dashboard/rss',
        newPath: 'feeds/rss-feed',
        andieDescription: 'Manage your RSS feeds. You can add, edit and delete RSS feeds.',
    },

    {
        oldPath: 'competitors/monitoring',
        newPath: 'feeds/competitor-monitoring',
        andieDescription: 'Monitor your competitors posts.',
    },

    {
        oldPath: 'competitors',
        newPath: 'feeds/competitor-monitoring',
        andieDescription: 'Monitor your competitors posts. You can add, edit and delete competitors.',
    },

    {
        oldPath: 'dashboard',
        newPath: 'feeds',
        andieDescription: 'Shows the feed of your social media profiles. You can manage your feed here.',
    },

    {
        oldPath: 'manage_social_networks',
        newPath: 'settings/workspace/social-profile',
        andieDescription:
            'This page is used to manage your social media profiles. You can add, update your profiles media tokens and remove them.',
    },
    {
        oldPath: 'personal_settings/account_status',
        newPath: 'settings/workspace/account-status',
        andieDescription:
            'Here you can see your profiles status. You can see if your profiles are connected and if they are working properly.',
    },
    {
        oldPath: 'team_management/management',
        newPath: 'settings/workspace/team',
        andieDescription:
            'This page is used to manage your team members. You can add, edit, manage permissions and remove team members.',
    },
    {
        oldPath: 'team_management',
        newPath: 'settings/workspace/team',
        andieDescription:
            'This page is used to manage your team members. You can add, edit, manage permissions and remove team members.',
    },
    {
        oldPath: 'personal_settings/integrations',
        newPath: 'settings/workspace/integrations',
        andieDescription:
            'Manage your legacy integrations like Slack(bot). You can add, edit and remove integrations.',
    },
    {
        oldPath: 'personal_settings/notifications',
        newPath: 'settings/personal/notifications-legacy',
        andieDescription: 'Legacy notification settings (kept during migration to the new notifications).',
    },
    {
        oldPath: 'manage_channels',
        newPath: 'settings/workspace/groups',
        andieDescription:
            'Manage your social media groups, a group typically is group of social profiles that belong to the same brand. You can add, edit and remove groups.',
    },
    {
        oldPath: 'personal_settings/settings/post',
        newPath: 'settings/workspace/rss-content',
        andieDescription:
            'Manage your RSS content settings. Choose what content you want to be published base on RSS feed posts.',
    },
    {
        oldPath: 'personal_settings/settings/tokens',
        newPath: 'settings/workspace/api-keys',
        andieDescription: 'Manage the API keys for your wordpress plugin and website integration.',
    },
    ...(!BETTER_AUTH_UI_ENABLED
        ? [
              {
                  oldPath: 'personal_settings',
                  newPath: 'settings/personal/security',
                  andieDescription:
                      'Page with your personal security settings. Change your password, and manage your two-factor authentication.',
              },
          ]
        : []),
    // Once the new auth UI owns /settings/personal/security, the legacy security page becomes
    // unreachable. It stays exposed under a separate path (mirroring
    // settings/personal/notifications-legacy) for two reasons: QA needs it to switch on legacy 2FA and
    // create accounts that exercise the 2FA migration on sign-in, and sessions that predate Better Auth
    // are redirected here, because they cannot use the new page (see SettingsPersonalSecurity).
    ...(BETTER_AUTH_UI_ENABLED
        ? [
              {
                  oldPath: 'personal_settings',
                  newPath: 'settings/personal/security-legacy',
                  andieDescription:
                      'Legacy personal security settings (password and two-factor authentication), kept reachable in development and staging so legacy 2FA accounts can be created for testing.',
              },
          ]
        : []),
    {
        oldPath: 'team_management',
        newPath: 'team',
        andieDescription:
            'Manage your team members. You can add, edit, manage permissions and remove team members.',
    },
];

export { pathMatch };

interface OldLegacySyncAction {
    id?: string;
    type?: string;
    value?: string | null;
    selector?: string | null;
    html?: string | undefined;
    rect?: CSSStyleDeclaration;
    tour?: string;
    status?: boolean;
    set?: Properties;
}

const OldLegacyIframe = ({
    showBackdrop,
    setShowBackdrop,
}: Readonly<{
    showBackdrop: boolean;
    setShowBackdrop: React.Dispatch<React.SetStateAction<boolean>>;
}>) => {
    const pathName = useLocation().pathname;
    const navigate = useNavigate();
    const target = oldHost;

    const session = useSession();
    const { t } = useTranslation();

    const reactPaths = ['listening', 'export', 'offers', 'discover', 'badges'];

    const excludePaths = ['competitors/monitoring'];

    const { switchWorkspace } = useSwitchWorkspace();
    // legacySyncActions is reached from the message listener's []-deps effect, which would pin
    // the first render's switchWorkspace forever. That identity changes (it depends on `t`,
    // among others), so keep a live reference rather than a stale capture.
    const switchWorkspaceRef = useRef(switchWorkspace);
    useEffect(() => {
        switchWorkspaceRef.current = switchWorkspace;
    });

    // Rebind on every attach/detach rather than once on mount, so the window handle cannot
    // go stale across a remount. Mirrors LegacyIframe, where the NotFound branch can leave
    // the element unrendered.
    const setIframeNode = useCallback((node: HTMLIFrameElement | null) => {
        iframe = node?.contentWindow ?? null;
    }, []);

    // This component mounts once in PrivateLayout, so a listener that closes over one render keeps
    // that render's route forever. A user who entered on a Fenix page then had `showOldLegacy`
    // (sent with every legacy plan limit popup) read as "not on a legacy page" and was sent home
    // from the team page (DEV-4691). The listener stays bound once and calls the live handler.
    const handleMessageRef = useRef<(event: MessageEvent) => void>(() => {});
    useEffect(() => {
        handleMessageRef.current = (event: MessageEvent) => {
            if (target.indexOf(event.origin) !== -1 && isset(event.data) && isset(event.data.path)) {
                let path = event.data.path.replace('#', '');

                path = getPagePath(path, 'new');
                if (isOldLegacy && pathName !== path) {
                    navigate(path, { replace: true });
                }

                legacySyncActions(isset(event.data.action, {}));
            }
        };
    });

    useEffect(() => {
        const handleMessage = (event: MessageEvent) => handleMessageRef.current(event);

        window.addEventListener('message', handleMessage, false);

        return () => {
            window.removeEventListener('message', handleMessage, false);
        };
    }, []);

    const isOldLegacy = (() => {
        for (const paths of pathMatch) {
            if (null != matchPath({ path: `/${paths.newPath}/*` }, pathName)) {
                return 'new';
            } else if (null != matchPath({ path: `/${paths.oldPath}/*` }, pathName)) {
                return 'old';
            }
        }
        return false;
    })();

    const legacySyncActions = (data: OldLegacySyncAction) => {
        switch (isset(data.type, '')) {
            case 'switchAccount':
                if (data.id) {
                    switchWorkspaceRef.current({ idLegacy: parseInt(data.id) });
                }
                break;
            case 'event':
                document.getElementById('root')?.click();
                break;
            case 'fullscreen':
                if (document.querySelector('.Top.Bar')) {
                    document.querySelector<HTMLElement>('.Top.Bar')!.style.display = isset(data.value, false)
                        ? 'none'
                        : '';
                }
                break;
            case 'supportChat':
                (window as any).toggleChat(isset(data.value, true)); // eslint-disable-line @typescript-eslint/no-explicit-any
                break;
            case 'refreshUserData':
                session.refetch();
                break;
            case 'setDOM':
                if (data.selector && data.html && data.rect) {
                    if (document.getElementById('legacyElementFaker') !== null) {
                        document.getElementById('legacyElementFaker')!.remove();
                    }

                    const div = document.createElement('div');
                    div.id = 'legacyElementFaker';
                    div.innerHTML = data.html;
                    div.dataset.id = data.id;
                    div.style.position = 'absolute';
                    div.style.opacity = '0';
                    div.style.pointerEvents = 'none';
                    div.style.width = data.rect.width + 'px';
                    div.style.height = data.rect.height + 'px';

                    const topValue = Number(
                        data.rect.top + document.getElementById('oldPageIframe')!.getBoundingClientRect().top,
                    );
                    const leftValue = Number(
                        data.rect.left +
                            document.getElementById('oldPageIframe')!.getBoundingClientRect().left,
                    );
                    div.style.top = topValue + 'px';
                    div.style.left = leftValue + 'px';
                    div.style.overflow = 'hidden';

                    const rectHeight = Number(data.rect.height);
                    if (topValue + rectHeight > window.innerHeight) {
                        const outsideMargin = topValue + rectHeight - window.innerHeight;
                        if (rectHeight > outsideMargin) {
                            div.style.height = rectHeight - outsideMargin + 'px';
                        } else {
                            div.style.height = '10px';
                            div.style.top = window.innerHeight - 10 + 'px';
                        }
                    }

                    document.body.appendChild(div);
                }
                break;
            //TODO Commented while a solution is found for tours
            /* case 'tourController':
                if (data.tour) {
                    TourController.load(data.tour, (data) => sendMessage({ type: 'tourController', data }));
                }
                break;
            case 'tourController.status':
                sendMessage({ type: 'tourController.status', data: TourController.status() });
                break;
            case 'tourController.setStatus':
                if (data.tour && data.status) {
                    TourController.setStatus(data.status ? 'true' : 'false', data.tour);
                }
                break; */
            case 'popup': {
                const showPopup: boolean = isset(data.value, false);
                setShowBackdrop(showPopup);
                sendMessage({ type: 'popupsStatus', popup: showPopup });
                break;
            }
            case 'postHogSetPropertyFlags':
                if (data.set) {
                    posthog.setPersonPropertiesForFlags(data.set);
                    posthog.reloadFeatureFlags();
                }
                break;
            case 'logout':
                session.logout.logout();
                break;
            case 'upgrade-plan':
                navigate('/settings/workspace/billing', { replace: true });
                break;
            case 'showOldLegacy':
                if (!isOldLegacy) {
                    navigate('/home', { replace: true });
                }
                break;
            default:
                break;
        }
    };

    const lastPath = useRef('');

    const syncPaths = () => {
        const path = getPagePath(null, isOldLegacy === 'old' ? 'new' : 'old', false);

        if (lastPath.current !== path) {
            if (isOldLegacy) {
                if (isOldLegacy === 'new') {
                    sendMessage({ path: path });
                } else {
                    navigate(path, { replace: true });
                }
            }
            lastPath.current = path;
        }
    };

    // When the type is old, it means that the path is from the new app and you want to receive the old path
    // When the type is new, it means that the path is from the old app and you want to receive the new path
    const getPagePath = (path?: string | null, getType?: string, setState?: boolean) => {
        const type = getType || 'old';
        const inverseType = type === 'old' ? 'new' : 'old';
        const auxPath = path || pathName;
        let finalPath = null;

        setState = isset(setState, true);

        const allReactPaths = JSON.parse(JSON.stringify(reactPaths));

        let excludePath = false;
        for (const tempExcludePath of excludePaths) {
            if ((path || pathName).includes(tempExcludePath)) {
                excludePath = true;
            }
        }

        const invertedTypeIndex = (inverseType + 'Path') as keyof LegacyPath;
        const typeIndex = (type + 'Path') as keyof LegacyPath;

        if (!(allReactPaths.indexOf(auxPath) !== -1 && !excludePath)) {
            for (const paths of pathMatch) {
                if (
                    auxPath.startsWith('/' + paths[invertedTypeIndex] + '/') ||
                    auxPath.endsWith('/' + paths[invertedTypeIndex])
                ) {
                    if (typeof paths[typeIndex] === 'string') {
                        finalPath = auxPath.replace('/' + paths[invertedTypeIndex], '/' + paths[typeIndex]);
                        break;
                    }
                }
            }
        }

        if (setState) {
            preventHistoryRender.current = true;
            setTimeout(() => (preventHistoryRender.current = false), 100);
        }

        if (finalPath) {
            return finalPath;
        }

        return lastPath.current || (isOldLegacy ? auxPath : '/' + pathMatch[0][typeIndex]);
    };

    const preventHistoryRender = useRef(true);

    useEffect(() => {
        if (!preventHistoryRender.current) {
            syncPaths();
        }
    });

    const initialSrc = useRef(target + '/#' + getPagePath(null, 'old', false));

    // Check if the user has access to the current path
    const notFound = !usersPathFilterAccess(pathName, session.workspace);

    // Sessions that predate Better Auth land here from the new security page, which cannot work for
    // them. Say so, so nobody thinks the app regressed to the old design.
    const isLegacySecurityPage =
        matchPath({ path: '/settings/personal/security-legacy/*' }, pathName) !== null;

    return (
        <>
            {notFound && <NotFound />}
            {isLegacySecurityPage && (
                <Alert severity="info" icon={<CampaignRounded />} sx={{ borderRadius: 0 }}>
                    <AlertTitle>{t('security.legacy-session.title')}</AlertTitle>
                    {t('security.legacy-session.notice')}
                </Alert>
            )}
            <iframe
                title="Page"
                id="oldPageIframe"
                allow="clipboard-write"
                width={'100%'}
                height={'100%'}
                src={initialSrc.current}
                ref={setIframeNode}
                style={{
                    display: notFound ? 'none' : 'block',
                    border: '0px solid',
                    flex: '1 1 auto',
                    ...(showBackdrop && {
                        zIndex: 1401,
                    }),
                }}
                onLoad={() => {
                    /* isIframeLoaded = true;
                setPostHogIdentify(); */
                }}
            ></iframe>
        </>
    );
};

export default OldLegacyIframe;

type SendMessageSet = {
    name: string;
    email: string;
    activeTeam: number | null;
    language: string;
    teams: Array<number>;
};
type SendMessageData = {
    type?: string;
    path?: string;
    className?: string;
    id?: string;
    set?: SendMessageSet | PostHogActionProperties;
    selector?: string | HTMLElement;
    data?: CallCallbackParams | { name: string | null; running: boolean };
    popup?: boolean;
};

export function sendMessage(data: SendMessageData) {
    if (iframe) {
        iframe.postMessage(data, oldHost);
    }
}

export function deleteFakeElement() {
    if (document.getElementById('legacyElementFaker') !== null) {
        document.getElementById('legacyElementFaker')!.remove();
    }
}

export function redirectHashroutes() {
    // Redirect Old Legacy urls hash routes
    if (typeof window !== 'undefined') {
        if (window.location.hash.includes('#/')) {
            const routeWithoutHash = window.location.hash.replace('#', '');
            window.location.replace(routeWithoutHash);
        }
    }
}
